import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Link,
  IconButton,
  Divider,
} from "@mui/material";
import {
  Phone,
  Email,
  LocationOn,
  Facebook,
  Instagram,
  YouTube,
} from "@mui/icons-material";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box 
      component="footer" 
      sx={{ 
        backgroundColor: 'primary.main',
        color: 'white',
        mt: 'auto',
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography 
              variant="h5" 
              sx={{ 
                fontFamily: 'Playfair Display',
                fontWeight: 600,
                mb: 2,
                color: 'secondary.light'
              }}
            >
              Fritz Guitar & Fix
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.8 }}>
              Vakkundige gitaarreparatie. 
              Met jaren ervaring zorg ik ervoor dat uw gitaar weer 
              perfect klinkt en speelt.
            </Typography>
          </Grid>

          {/* Services */}
          <Grid item xs={12} md={4}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                mb: 2,
                color: 'secondary.light'
              }}
            >
              Mijn Kracht
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link 
                href="/reparaties" 
                sx={{ 
                  color: 'white', 
                  textDecoration: 'none',
                  '&:hover': { color: 'secondary.light' }
                }}
              >
                Gitaarreparatie
              </Link>
              <Link 
                href="/Inspiratieles" 
                sx={{ 
                  color: 'white', 
                  textDecoration: 'none',
                  '&:hover': { color: 'secondary.light' }
                }}
              >
                Inspiratieles
              </Link>
              <Link 
                href="/sessies" 
                sx={{ 
                  color: 'white', 
                  textDecoration: 'none',
                  '&:hover': { color: 'secondary.light' }
                }}
              >
                Gigs en Sessies
              </Link>
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={4}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                mb: 2,
                color: 'secondary.light'
              }}
            >
              Contact
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ fontSize: 20 }} />
                <Typography variant="body2">
                  <Link 
                    href="tel:+31658842923" 
                    sx={{ color: 'white', textDecoration: 'none' }}
                  >
                    06 58 84 29 23
                    </Link>
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email sx={{ fontSize: 20 }} />
                <Typography variant="body2">
                  <Link 
                    href="mailto:info@fritzguitarandfix.nl" 
                    sx={{ color: 'white', textDecoration: 'none' }}
                  >
                    info@fritzguitarandfix.nl
                  </Link>
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOn sx={{ fontSize: 20 }} />
                <Typography variant="body2">
                  Esdoornstraat 2<br />
                  5461CH Veghel
                </Typography>
              </Box>
            </Box>

            {/* Social Media */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Volg mij:
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <IconButton 
                  sx={{ 
                    color: 'white',
                    '&:hover': { color: 'secondary.light' }
                  }}
                  href="https://www.facebook.com/Fritzguitarandfix/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Facebook />
                </IconButton>
                <IconButton 
                  sx={{ 
                    color: 'white',
                    '&:hover': { color: 'secondary.light' }
                  }}
                  href="https://www.instagram.com/fritzguitarandfix/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Instagram />
                </IconButton>
                <IconButton 
                  sx={{ 
                    color: 'white',
                    '&:hover': { color: 'secondary.light' }
                  }}
                  href="https://www.youtube.com/@manzanagrande"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <YouTube />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.2)' }} />

        {/* Copyright */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            © {currentYear} Fritz Guitar & Fix. Alle rechten voorbehouden.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
